export default __webpack_public_path__ + "static/media/wrong.e8d01ba8.svg";